import { z } from 'zod';
import { ILegalClient } from '../../ILegalClient';
import { GenericLegalTransactionRelationshipMemberSchema } from '../GenericLegalTransactionRelationshipMemberSchema';
import { getEmptyMemberSkeleton } from '../ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipRoleEnum } from '../LegalTransactionRelationshipRoleEnum';

export const SignerMemberDataSchema = z.object({
  idTypeOfDocument: z.number(),
  textTypeOfDocument: z.string().nullable(),
  idAsProxy: z.number(),
  asProxy: z.boolean(),
  textAsProxy: z.string().nullable(),
  addToLegalTransaction: z.boolean().optional(),
});

export type IMemberSignerData = z.infer<typeof SignerMemberDataSchema>;

export const getEmptySignerMemberData = (): IMemberSignerData => ({
  idTypeOfDocument: 1, // Default type of document ID
  textTypeOfDocument: null, // Default text for type of document
  idAsProxy: 1, // Default ID for asProxy type
  asProxy: false, // Default asProxy state
  textAsProxy: null, // Default text for asProxy
});

export const SignerMemberSchema =
  GenericLegalTransactionRelationshipMemberSchema(
    z.literal(LegalTransactionRelationshipRoleEnum.Signer),
    SignerMemberDataSchema
  );

export type IMemberSigner = z.infer<typeof SignerMemberSchema>;

export const getEmptySignerMember = (
  legalClient: ILegalClient,
  idRelationship: number,
  data?: IMemberSignerData
): IMemberSigner => {
  const member: IMemberSigner = {
    ...getEmptyMemberSkeleton(legalClient, idRelationship),
    idRelationshipRole: LegalTransactionRelationshipRoleEnum.Signer,
    data: data || getEmptySignerMemberData(),
  };

  return member;
};
